
import { BaseResourceApi, type IResourceApiContext, type ApiOptions, type BaseRequestOptions } from './common'
import { createSchemaApiRequest, type ApiSchemaRequest, type ApiSchemaResponse } from './schema'

export class UserMediaApi extends BaseResourceApi {
  options: ApiOptions
  constructor (ctx: IResourceApiContext, options?: ApiOptions) {
    super(ctx)
    this.options = {
      currentUser: false,
      ...options
    }
  }

  async get (config: ApiSchemaRequest<'/user-medias/{id}', 'get'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/user-medias/{id}', 'get'>> {
    return await createSchemaApiRequest({
      path: '/user-medias/{id}',
      method: 'get',
      ctx: this.ctx,
      params: config.params,
      options: config
    })
  }

  async list (config: ApiSchemaRequest<'/user-medias', 'get'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/user-medias', 'get'>> {
    return await createSchemaApiRequest({
      path: this.options.currentUser ? '/currentuser/media' : '/user-medias',
      method: 'get',
      ctx: this.ctx,
      query: config.query,
      options: config
    })
  }

  async count (config: ApiSchemaRequest<'/user-medias/count', 'get'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/user-medias/count', 'get'>> {
    return await createSchemaApiRequest({
      path: this.options.currentUser ? '/currentuser/media/count' : '/user-medias/count',
      method: 'get',
      ctx: this.ctx,
      query: config.query,
      options: config
    })
  }

  async insert (config: ApiSchemaRequest<'/user-medias', 'post'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/user-medias', 'post'>> {
    return await createSchemaApiRequest({
      path: '/user-medias',
      method: 'post',
      ctx: this.ctx,
      data: config.data,
      options: config
    })
  }

  async update (config: ApiSchemaRequest<'/user-medias/{id}', 'put'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/user-medias/{id}', 'put'>> {
    return await createSchemaApiRequest({
      path: '/user-medias/{id}',
      method: 'put',
      params: config.params,
      ctx: this.ctx,
      data: config.data,
      query: config.query,
      options: config
    })
  }

  async delete (config: ApiSchemaRequest<'/user-medias/{id}', 'delete'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/user-medias/{id}', 'delete'>> {
    return await createSchemaApiRequest({
      path: '/user-medias/{id}',
      method: 'delete',
      params: config.params,
      ctx: this.ctx,
      query: config.query,
      options: config
    })
  }
}

export {}
